import { ApiClientErrorResponse } from '~/ApiClient';

export default class ProductErrorResponse extends ApiClientErrorResponse {
	handleProductNotFound(): boolean {
		return this.handle('product-not-found');
	}
}
